<div class="help-image-box {{extraClasses}}" [ngStyle]="style">
  
  <co-image *ngIf="!showMessageBox" isVault="true" (imageError)="onImageError($event)" type="png" [key]="valueModel.helpImage" [height]="groupModel.helpImageHeight"></co-image>
  
  <div  *ngIf="showMessageBox" class="h-100 justify-content-center align-middle message-box frame">
    <span class="message">{{message}}</span>
  </div>

</div>